export const IconSMS = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.6641 28.3333H9.33073C4.46406 28.3333 1.66406 25.5333 1.66406 20.6666V11.3333C1.66406 6.46663 4.46406 3.66663 9.33073 3.66663H22.6641C27.5307 3.66663 30.3307 6.46663 30.3307 11.3333V20.6666C30.3307 25.5333 27.5307 28.3333 22.6641 28.3333ZM9.33073 5.66663C5.5174 5.66663 3.66406 7.51996 3.66406 11.3333V20.6666C3.66406 24.48 5.5174 26.3333 9.33073 26.3333H22.6641C26.4774 26.3333 28.3307 24.48 28.3307 20.6666V11.3333C28.3307 7.51996 26.4774 5.66663 22.6641 5.66663H9.33073Z" fill="#979797"/>
      <path d="M15.9984 17.16C14.8784 17.16 13.7451 16.8133 12.8784 16.1066L8.70507 12.7733C8.2784 12.4266 8.19841 11.8 8.54507 11.3733C8.89174 10.9466 9.51841 10.8666 9.94508 11.2133L14.1184 14.5466C15.1317 15.36 16.8517 15.36 17.8651 14.5466L22.0384 11.2133C22.4651 10.8666 23.1051 10.9333 23.4384 11.3733C23.7851 11.8 23.7184 12.44 23.2784 12.7733L19.1051 16.1066C18.2517 16.8133 17.1184 17.16 15.9984 17.16Z" fill="#979797"/>
    </svg>
  );
};
